import React from 'react'

const About = () => {
  return (
    <div
    name="about"
    className="w-full h-screen bg-gradient-to-b from-gray-800  
    to-black text-white"
    >
        <div className="max-w-screen-lg p-4 mx-auto flex flex-col justify-center w-full h-full">
            <div className="pb-8">
                <p className="text-4xl font-bold inline border-b-4 
                border-gray-500">
                    About
                    </p>
            
        </div>
        <p className="text-lg mt-20">
          I am a web developer located in Arizona. I build full responsive websites
          and mobile ready HTML Emails. I use Javascript and related libraries. I 
          like subtle and easy to access websites with a clean UI/UE. 
        </p>
        <br />

        <p className="text-lg ">Projects and Github listed below:

        </p>
      </div> 
    </div>
  )
}

export default About
